import { Flex, Box } from "@chakra-ui/react";
import React from "react";
import { useSelector } from "react-redux";
import DashboardWrapper from "../../Auth/AuthWrapper";
import {
  ASSISTANT_ALLOWED_PATHS,
  roleNameFromUser,
} from "../../../constants/assistantAccess";
import SuperAdminSidenavbar from "../sideNavbars/superAdminSidenavbar";
import TeacherSidenavbar from "../sideNavbars/teacherSidenavbar";
import MobileSidebar, {
  MOBILE_TOP_BAR_OFFSET,
} from "../sideNavbars/mobile-sidebar";
const Layout = ({ children }) => {
  const userData = useSelector((state) => state.user.userData);
  const roleName = roleNameFromUser(userData);
  const isTeacher = roleName === "Teacher";
  const isAssistant = roleName === "Assistant";
  const sidebarWidth = "260px";

  return (
    <DashboardWrapper roles={["Admin", "Super Admin", "Teacher", "Assistant"]}>
      <Flex w="100%" minH="100vh" dir="ltr" bg="var(--surface-canvas)">
        <Box display={{ base: "none", md: "block" }}>
          {roleName
            ? isTeacher || isAssistant
              ? (
                <TeacherSidenavbar
                  allowedPaths={isAssistant ? ASSISTANT_ALLOWED_PATHS : null}
                  hideNotifications={isAssistant}
                />
              )
              : <SuperAdminSidenavbar />
            : null}
        </Box>
        <MobileSidebar />
        <Box
          flex="1"
          w="100%"
          minW={0}
          pl={{ base: 0, md: sidebarWidth }}
          pr={{ base: 0, md: 6 }}
          pt={{ base: MOBILE_TOP_BAR_OFFSET, md: 0 }}
        >
          <Box w="100%" minH="100vh" overflowX="auto" bg="var(--surface-canvas)">
            {children}
          </Box>
        </Box>
      </Flex>
    </DashboardWrapper>
  );
};

export default Layout;
